/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
const { string, arrayOf } = proptypes;
import { useDataModel } from '@thd-nucleus/data-sources/react/dataModel/useDataModel';
import { WarningFilled } from '@one-thd/sui-icons';
import { Link } from '@one-thd/sui-atomic-components';
import { dataModel } from './dataModel';
import { SERVICE_MESSAGES, HOME_DEPOT_QUOTE_CENTER } from './constants';

const NonBuyableQuoteCenter = ({ itemId, checkForProductSubType = null }) => {
  const opts = {
    variables: {
      itemId
    },
    skip: !itemId
  };
  const { data, loading, error } = useDataModel('product', opts);

  if (!data) {
    return null;
  }

  const { details, info } = data?.product || {};
  const { serviceType } = details?.installation || {};
  const { name } = info?.productSubType || {};

  let isQuoteCenter = serviceType === HOME_DEPOT_QUOTE_CENTER;

  if (checkForProductSubType?.includes('HDQC')) {
    isQuoteCenter = name === HOME_DEPOT_QUOTE_CENTER;
  }

  if (!isQuoteCenter) {
    return null;
  }

  return (
    <div className="sui-border-1 sui-border-solid sui-border-warning sui-p-4" data-component="NonBuyableQuoteCenter">
      <div className="sui-align-baseline">
        <WarningFilled color="warning" size="small" />
        <span className="sui-text-xs sui-font-bold sui-pl-1">{SERVICE_MESSAGES.SPECIAL_ORDER}</span>
      </div>
      <div className="sui-text-xs sui-mt-2 sui-mb-2">
        {SERVICE_MESSAGES.VISIT_PRO_DESK}
        <Link underline="always" variant="body-xs" href={`tel:${SERVICE_MESSAGES.PHONE_NUMBER}`} weight="bold">
          {SERVICE_MESSAGES.PHONE_NUMBER}
        </Link>
        {SERVICE_MESSAGES.DELIVERY_AVAILABILITY}
      </div>
    </div>
  );
};

NonBuyableQuoteCenter.propTypes = {
  itemId: string.isRequired,
  checkForProductSubType: arrayOf(string)
};

NonBuyableQuoteCenter.displayName = 'NonBuyableQuoteCenter';

NonBuyableQuoteCenter.dataModel = dataModel;

export { NonBuyableQuoteCenter };
